import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { cva, VariantProps } from "class-variance-authority";
import { SheetContent } from "@/v2-components/ui/sheet";

const variants = cva([], {
  variants: {},
  defaultVariants: {},
});

interface DrawerProps
  extends
    React.ComponentPropsWithoutRef<typeof Dialog.Content>,
    VariantProps<typeof variants> {
  open?: boolean;
  overlayClassName?: string;
  onOpenChange?: (change: boolean) => void;
  className?: string;
  side: "bottom" | "top" | "left" | "right" | "center";
}

const Drawer = React.forwardRef<
  React.ElementRef<typeof Dialog.Content>,
  DrawerProps
>(({ open, onOpenChange, side, children, ...props }, ref) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Description className="hidden" />
      <Dialog.Title className="hidden" />
      <SheetContent side={side} ref={ref} {...props}>
        {children}
      </SheetContent>
    </Dialog.Root>
  );
});

Drawer.displayName = "Drawer";

export { Drawer };
